<template>
	<div class="data_inventory">
		<el-divider content-position="left">工商注册数据盘点</el-divider>
        <el-row style="margin-bottom: .2rem;">
            <el-date-picker v-model="nowDate" type="date" value-format="yyyy-MM-dd" placeholder="选择派单日期" size="mini" @change="getPageData" :picker-options="pickerOptions"></el-date-picker>
        </el-row>
        <el-row>
            <el-table :data="pageData.gs_order_count" style="width: 100%" border size="medium" @sort-change="handleSortChange">
                <el-table-column label="订单来源" prop="platform"" :filters="originalArray" :filter-method="filterHandler"></el-table-column>
                <el-table-column label="当日订单数量" prop="count" sortable>
                    <template slot-scope="scope">
                        <span class="gs_order" @click="showGsOrders(scope.row.platform)">{{ scope.row.count }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="当日分配"" sortable prop="assignCount">
                    <template slot-scope="scope">
                        <span class="gs_order" @click="showAssignCount(scope.row.assignCount)">{{ scope.row.assignCount ? scope.row.assignCount.length : '' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="当日订单转信息表"" prop="docInfoCount" sortable>
                    <template slot-scope="scope">
                        <span class="gs_order" @click="showGsDocinfos(scope.row.docInfoCount)">{{ scope.row.docInfoCount.length > 0 ? scope.row.docInfoCount.length : '' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="当日信息表转化率"">
                    <template slot-scope="scope">
                        <span>{{ scope.row.docInfoCount.length > 0 ? scope.row.docInfoCount.length + '/' + scope.row.count : '' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="非今日订单转化" prop="notTodayDocInfoCount" sortable>
                    <template slot-scope="scope">
                        <span class="gs_order" @click="showNotTodayDocInfo(scope.row.notTodayDocInfoCount)">{{ scope.row.notTodayDocInfoCount.length > 0 ? scope.row.notTodayDocInfoCount.length : '' }}</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-row>
                <el-col :span="4">
                    <div class="data_count">
                        <span class="my_td">总计：</span>
                    </div>
                </el-col>
                <el-col :span="4" v-for="(item, index) in totals" :key="index">
                    <div class="data_count">
                        <span class="my_td">{{ item.name }} 
                            <span>{{ item.count }}</span>
                            <span v-if="item.name === '分配'"> + <span class="gs_order" @click="showAssignCount(pageData.calculateNotTodayAssignOrderTotal)">{{ pageData.calculateNotTodayAssignOrderTotal.length }}</span></span>
                        </span>
                    </div>
                </el-col>
            </el-row>
        </el-row>
		<el-drawer
      title="订单"
      :visible.sync="showGsOrderDrawer"
      :append-to-body="true"
      direction="rtl"
      :before-close="handleGsOrderBeforeClose"
      size="60%"
    >
    	<div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
    		<el-table :data="gsOrders" style="width: 100%" border size="medium">
    			<el-table-column fixed label="订单编号" prop="order_num" width="330"></el-table-column>
    			<el-table-column label="订单来源" prop="platform"></el-table-column>
    			<el-table-column label="沟通专员(业务)" >
    				<template slot-scope="scope">
    					<div v-if="scope.row.advisor">
    						{{ scope.row.advisor.username }}
    					</div>
    				</template>
    			</el-table-column>
    		</el-table>
    		<el-row style="margin-top: .2rem; text-align: right;">
    			<el-pagination
    			  background
    			  class="tr"
    			  layout="total, sizes, prev, pager, next, jumper"
    			  :hide-on-single-page="false"
    			  :current-page="gsPageOption.currentPage"
    			  :page-size="gsPageOption.pageSize"
    			  :total="gsPageOption.total"
    			  @current-change="handleGsCurrentChange"
    			>
    			</el-pagination>
    		</el-row>
    	</div>
    </el-drawer>
    <el-drawer
      title="当日分配订单"
      :visible.sync="showAssignCountDrawer"
      :append-to-body="true"
      direction="rtl"
      :before-close="handleAssignCountBeforeClose"
      size="60%"
    >
        <div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
            <el-table :data="assignCountData" style="width: 100%" border size="medium">
                <el-table-column fixed label="订单编号" prop="order_num" width="330"></el-table-column>
                <el-table-column label="订单来源" prop="platform" width="220"></el-table-column>
                <el-table-column label="沟通专员(业务)" >
                    <template slot-scope="scope">
                        <div v-if="scope.row.advisor">
                            {{ scope.row.advisor.username }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="派单时间" prop="assign_at" width="220"></el-table-column>
            </el-table>
        </div>
    </el-drawer>
		<el-drawer
      title="非今日订单转化"
      :visible.sync="showNotTodayDocInfoDrawer"
      :append-to-body="true"
      direction="rtl"
      :before-close="handleNotTodayDocInfoBeforeClose"
      size="60%"
    >
    	<div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
    		<el-table :data="gsNotTodayDocInfos" style="width: 100%" border size="medium">
    			<el-table-column fixed label="订单编号" prop="order_num" width="330"></el-table-column>
    			<el-table-column label="订单来源" prop="platform" width="220"></el-table-column>
    			<el-table-column label="沟通专员(业务)" >
    				<template slot-scope="scope">
    					<div v-if="scope.row.advisor">
    						{{ scope.row.advisor.username }}
    					</div>
    				</template>
    			</el-table-column>
    			<el-table-column label="信息表合格时间" prop="doc_timed" width="220"></el-table-column>
    			<el-table-column label="派单时间" prop="assign_at" width="220"></el-table-column>
    		</el-table>
    	</div>
    </el-drawer>
    <el-drawer
      title="信息表"
      :visible.sync="showGsDocInfoDrawer"
      :append-to-body="true"
      direction="rtl"
      :before-close="handleDocInfoBeforeClose"
      size="60%"
    >
    	<div class="m-tabs-content" style="padding: 0px 0.2rem 0px 0.4rem">
    		<el-table :data="gsDocInfos" style="width: 100%" border size="medium">
    			<el-table-column fixed label="订单编号" prop="order_num" width="330"></el-table-column>
    			<el-table-column label="订单来源" prop="platform" width="220"></el-table-column>
    			<el-table-column label="沟通专员(业务)" >
    				<template slot-scope="scope">
    					<div v-if="scope.row.advisor">
    						{{ scope.row.advisor.username }}
    					</div>
    				</template>
    			</el-table-column>
    			<el-table-column label="信息表合格时间" prop="doc_timed" width="220"></el-table-column>
    			<el-table-column label="派单时间" prop="assign_at" width="220"></el-table-column>
    		</el-table>
    	</div>
    </el-drawer>
	</div>
</template>

<script>
export default {
  name: "DataInventory",
  data() {
    return {
        nowDate: '',
        pickerOptions: {
            disabledDate (time) {
                // 禁止选择当前日期之后的日期
                const now = new Date()
                const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
                return time.getTime() > today.getTime()
            }
        },
    	pageData: [],
    	gsOrders: [],
    	platform: '',
    	docPlatform: '',
    	showNotAssignOrderDrawer: false,
    	showGsOrderDrawer: false,
    	gsPageOption: {
    	  total: 0,
    	  currentPage: 1, // 当前页数
    	  searchCurrentPage: 1,
    	  pageSize: 20, // 每页显示条数
    	},
        showAssignCountDrawer: false,
        assignCountData: [],
    	showNotTodayDocInfoDrawer: false,
    	gsDocInfos: [],
        gsNotTodayDocInfos: [],
    	showGsDocInfoDrawer: false,
        totals: [],
        originalArray: [],
        columArr: []
    };
  },
  computed: {
  },
  methods: {
    formatDate () {
        let date = new Date()
        let year = date.getFullYear()
        let month = (1 + date.getMonth()).toString()
        month = month.padStart(2, '0')
        let day = date.getDate().toString()
        day = day.padStart(2, '0')

        return year + '-' + month + '-' + day
    },
    getPageData() {
    	this.$axios.get('/api/admin/tyc_order/data_inventory?date=' + this.nowDate)
    		.then((res) => {
    			const { data } = res
    			if (data.code === 0) {
    				this.pageData = data.data
                    this.mergePageData(data.data.gs_order_count, data.data.gs_not_today_doc_info_count)
                    // this.getTotals()
    			}
    		})
    },
    mergePageData (orders, notTodayDocInfos) {
        // 过滤出数组2中不存在于数组1中的对象
        const missingItems = notTodayDocInfos.filter(item2 => !orders.some(item1 => item1.platform === item2.platform))


        for (var i = 0; i < missingItems.length; i++) {
            if (orders.some(item => item.platform === missingItems[i].platform)) {
                let index = orders.findIndex(item => item.platform === missingItems[i].platform)
                orders[index].notTodayDocInfoCount.push(missingItems[i])
            } else {
               orders.push({ platform: missingItems[i].platform, assignCount: [],  count: 0, docInfoCount: [], notTodayDocInfoCount: [missingItems[i]]}) 
            }
        }

        this.transformArray(orders)

        this.getTotals(orders, this.pageData.gs_assign_order_count, this.pageData.gs_doc_info_count, this.pageData.gs_not_today_doc_info_count)
    },
    getTotals (data, gsAssignOrderCount, gsDocInfoCount, gsNotTodayDocInfoCount) {
        this.totals = []
        let orderCount = 0;
        for (var i = 0; i < data.length; i++) {
            orderCount += data[i].count
        }

        this.totals.push({name: '订单', count: orderCount}, {name: '分配', count: gsAssignOrderCount.length}, {name: '信息表', count: gsDocInfoCount.length}, {name: '', count: gsDocInfoCount.length + '/' + gsAssignOrderCount.length}, {name: '信息表', count: gsNotTodayDocInfoCount.length})
    },
    getGsOrderTotal () {
    	let total = 0
    	for (var i = 0; i < this.pageData.gs_order_count.length; i++) {
    		total += this.pageData.gs_order_count[i].count
    	}
    	return total
    },
    showNotAssignOrder () {
    	this.showNotAssignOrderDrawer = true
    },
    handleNotAssignOrderBeforeClose (done) {
    	done()
    },
    getGsOrders (platform) {
    	this.$axios.get('/api/admin/tyc_order/data_inventory/getGsOrder?page=' + this.gsPageOption.currentPage + '&platform=' + this.platform + '&date=' + this.nowDate)
    		.then((res) => {
    			const { data } = res
    			if (data.code === 0) {
    				this.gsOrders = data.data.data
    				this.gsPageOption.total = data.data.total
    				this.showGsOrderDrawer = true
    			}
    		})
    },
    handleGsCurrentChange(val) {
      this.gsPageOption.currentPage = val;
      this.getGsOrders();
    },
    showGsOrders (platform) {
    	this.platform = platform
    	this.getGsOrders()
    },
    handleGsOrderBeforeClose (done) {
    	done()
    },
    getGsDocTotal () {
    	let total = 0
    	for (var i = 0; i < this.pageData.gs_doc_info_count.length; i++) {
    		total += this.pageData.gs_doc_info_count[i].count
    	}
    	return total
    },
    showAssignCount (data) {
        this.assignCountData = data
        this.showAssignCountDrawer = true
    },
    handleAssignCountBeforeClose (done) {
        this.assignCountData = []
        done()
    },
    showGsDocinfos (data) {
        this.gsDocInfos = data
        this.showGsDocInfoDrawer = true
    },
    handleDocInfoBeforeClose (done) {
        this.gsDocInfos = []
        done()
    },
    showNotTodayDocInfo (data) {
    	this.showNotTodayDocInfoDrawer = true
        this.gsNotTodayDocInfos = data
    },
    handleNotTodayDocInfoBeforeClose (done) {
        this.gsNotTodayDocInfos = []
        done()
    },
    customSort (a, b) {
        return -1
    },
    handleSortChange ({ column, prop, order }) {
        // console.log(prop)
    },
    filterHandler (value, row, column) {
        this.columArr = []
        let gsAssignOrderCount = []
        let gsDocInfoCount = []
        let gsNotTodayDocInfoCount = []
        const property = column['property']
        
        this.columArr = this.pageData.gs_order_count.filter(item => column.filteredValue.includes(item.platform));

        for (var i = 0; i < this.columArr.length; i++) {
            gsAssignOrderCount = gsAssignOrderCount.concat(...this.columArr[i].assignCount)
            gsDocInfoCount = gsDocInfoCount.concat(...this.columArr[i].docInfoCount)
            gsNotTodayDocInfoCount = gsNotTodayDocInfoCount.concat(this.columArr[i].notTodayDocInfoCount)
        }


        this.getTotals(this.columArr, gsAssignOrderCount, gsDocInfoCount, gsNotTodayDocInfoCount)

        return row[property] === value
    },
    transformArray (data) {
        this.originalArray = data.map(item => ({
            text: item.platform,
            value: item.platform
        }))
    }
  },
  mounted() {
    this.nowDate = this.formatDate()
    this.getPageData();
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/vertical.styl'

.data_inventory
	marginLeft()
.el-drawer__wrapper >>> .el-drawer {
  overflow-y: auto;
}

.data_inventory >>> .el-table__column-filter-trigger i{
    font-size: 16px;
}

.info-text {
	text-align: center;
	padding: .2rem 0;
}
.gs_order {
	cursor: pointer;
	color: #5787FF;
}
.data_count {
    height: 24px;
    padding .2rem 0;
}
.my_td {
    display: table-cell;
    padding 0 .2rem;
}
</style>


// WEBPACK FOOTER //
// src/pages/tyc_order/DataInventory.vue